import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "ui/base/Button";
import Typography from "@mui/material/Typography";


Modal.Title = ({ children, onClose, ...props }) => {
	const style = {
		root: {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			p: 2
		}
	};
	return (
		<DialogTitle variant="h2" color="text.primary" {...props} sx={{ ...style.root, ...props.sx }}>
			{children}
			{onClose && <Button.Icon icon="x" color="text.secondary" size={28} onClick={onClose} sx={{ p: 0 }} />}
		</DialogTitle>
	);
};

Modal.Content = (props) => {
	const style = {
		root: {
			display: "flex",
			flexDirection: "column",
			gap: 2,
			p: 2,
			overflow: "auto"
		}
	};

	return <DialogContent {...props} sx={{ ...style.root, ...props.sx }} />;
};

Modal.Actions = (props) => {
	const theme = useTheme();
	const fullScreen = useMediaQuery(t => t.breakpoints.down("md"));

	const style = {
		root: {
			flexDirection: fullScreen ? "column" : "row",
			gap: 2,
			alignItems: "stretch",
			p: theme.spacing(0, 2, 2)
		}
	};

	return <DialogActions {...props} sx={{ ...style.root, ...props.sx }} />;
};

Modal.Confirmation = ({ title, text, actions, ...props }) => (
	<Modal {...props}>
		{title && <Modal.Title onClose={props.onClose}>{title}</Modal.Title>}
		<Modal.Content>
			<Typography variant="body2">
				{text}
			</Typography>
		</Modal.Content>
		<Modal.Actions>
			{actions.map(({ label, ...action }, i) => <Button variant="contained" {...action} key={i}>{label}</Button>)}
		</Modal.Actions>
	</Modal>
);

export default function Modal({ children, maxWidth = "sm", ...props }) {
	const fullScreen = useMediaQuery(t => t.breakpoints.down("sm"));

	const style = {
		paper: {
			borderRadius: fullScreen ? 0 : "16px"
		}
	};

	return (
		<Dialog fullScreen={fullScreen} slotProps={{ paper: { sx: style.paper } }} fullWidth maxWidth={maxWidth} {...props}>
			{children}
		</Dialog>
	);
}